import { Button } from '@hivebrite/design-system/Button';

import { useBuilderContext } from 'hb-builder/hooks';
import { createNewItem } from 'hb-builder/utils/createNewItem';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { HeroSliderItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/heroSliderItemAttributes';

const MAXIMUM_SLIDES = 6;

const AddSlideButton = ({
  item,
}: {
  item: DocumentItem<HeroSliderItemAttributes>;
}) => {
  const slides = item.children;
  const { addItem, getPath } = useBuilderContext();

  const addSlide = (slidesCollection) => {
    const newSlide = createNewItem(slidesCollection[0], { isDuplicate: true });

    addItem({
      path: getPath(item.id),
      id: item.id,
      direction: slidesCollection.length + 1,
      item: newSlide,
    });
  };

  return (
    <Button
      fontFamily="Inter"
      isDisabled={slides && slides.length >= MAXIMUM_SLIDES}
      mt="10px"
      mx={5}
      onClick={() => addSlide(slides)}
      variant="primary"
    >
      {__('Add slide')}
    </Button>
  );
};

export default AddSlideButton;
